export default __webpack_public_path__ + "static/media/road.c958c8a6.svg";